var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-restore",attrs:{"visible":_vm.show,"title":_vm._f("translate")(_vm.headerText),"ok-title":_vm._f("translate")('Confirm'),"cancel-title":_vm._f("translate")('Cancel'),"ok-disabled":_vm.isOkDisabled},on:{"hide":function () { return this$1.$emit('close'); },"ok":function () { return _vm.$emit('restoreStudent'); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }